import Service from "../../../service/api.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {

        item:[],
        isReload: false,
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        }
    },

    actions: {
        config({commit}, data) {
            return Service.Report_Method('report_method', data, {})
                .then((response) => {
                    store.commit("rMethod/item", response.data.data)
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response
                }).catch((err) => {
                    throw err
            });
        },
        create({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.assessment('post', {...data}, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
        update({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.assessment('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },

        remove({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.assessment('delete', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response

                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },

    },

    getters: {
        item(state, obj) {
            return state.item;
        },

        isReload(state, obj) {
            return state.isReload;
        }
    },
};

export default ServerModule;
